import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  
  {
    title: 'ENTERPRISE',
    //group: true,
    link: '/em-pages/enterprise-module/enterprise',
  },
 
  {
    title: 'CUSTOMIZING',
   // group: true,
    link: '/em-pages/customizing/calendar',
  },
 {
    title: 'RESOURCE',
   // group: true,
    link: '/em-pages/resource-module/resource-human',
  },
];
